import * as React from 'react';
import {FC} from 'react';
import OutboundOrdersService from '../OutboundOrdersService';

interface Props {
  showOmniOrderCreateBtn: boolean;
  companyId: number;
  createNewOrdersButtonFlagOn: boolean;
  outboundOrdersService: OutboundOrdersService;
}

// TODO cleanup this misnomer after this is stable. New is actually just old retail.
function shouldNewOrdersButtonBeShown(
  currentCompanyId: number,
  createNewOrdersButtonFlagOn: boolean,
  outboundOrdersService: OutboundOrdersService
): boolean {
  switch (currentCompanyId) {
    //+3 fritolay
    case 579:
    case 1000:
    case 3500:
    // niagara
    case 3475:
    //+3 lol
    case 564:
    case 1907:
    case 2012:
      return true;
    default:
      return createNewOrdersButtonFlagOn && outboundOrdersService && outboundOrdersService.isAdmin();
  }
}

const CreateSingleOrderButton: FC<Props> = (props) => {
  if (props.showOmniOrderCreateBtn) {
    return (
      <a href="/s/fulfillment/omnichannel/orders/new" className="btn pull-right" id="new-manual-request">
        <i className="fa fa-plus" />
        &nbsp; Create New Order
      </a>
    );
  }

  const showButton = shouldNewOrdersButtonBeShown(
    props.companyId,
    props.createNewOrdersButtonFlagOn,
    props.outboundOrdersService
  );

  return (
    <>
      {showButton && (
        <a href={'/s/fulfillment/orders/new'} className="btn pull-right" id="new-manual-request">
          <i className="fa fa-plus" />
          &nbsp; Create New Order
        </a>
      )}
    </>
  );
};
export default CreateSingleOrderButton;
